export default __webpack_public_path__ + "static/media/shortblast-home.6a0ea211.png";